const pillars = state => {
  return [state.firstPillar, state.secondPillar, state.thirdPillar]
}

const disablePillarToggle = (_, getters) => pillarId => {
  const maxClosedPillars = getters.pillars.length - 1

  return (
    getters.pillars.filter(pillar => pillar.id !== pillarId && !pillar.isOpen)
      .length === maxClosedPillars
  )
}

const openPillars = (state, getters, _, rootGetters) => {
  const visiblePillars = getters.pillars.filter(value => value.isOpen)
  const channelMenuOpen = rootGetters['ui/channelBar/isMenuOpen'] ? 1 : 0
  return visiblePillars.length + channelMenuOpen
}

const has3PillarsOpen = (_, getters) => {
  return getters.openPillars === 3
}

const notifications = state => state.notifications

const getNumberOfTabsOpen = (_, getters) => tab => {
  return getters.pillars.filter(
    pillar => pillar.tabs.includes(tab) && pillar.isOpen
  )?.length
}

export default {
  pillars,
  openPillars,
  has3PillarsOpen,
  disablePillarToggle,
  notifications,
  getNumberOfTabsOpen
}
